export const Irs=
[
    { "name" :"170(c)(1) Government Entity"},
    { "name" :"4947(a)(1) Non-Exempt Charitable Trusts (Private Foundation)"},
    { "name" :"4947(a)(1) Non-Exempt Charitable Trusts (Public Charity)"},
    { "name" :"4947(a)(2) Split-Interest Trust"},
    { "name" :"501(c)(1) Government Instrumentality"},
    { "name" :"501(c)(10) Domestic Fraternal Societies"},
    { "name" :"501(c)(11) Teachers Retirement Fund Associations"},
    { "name" :"501(c)(12) Local Benevolent Life Insurance Associations, Mutual Irrigation and Telephone Companies, and Like Co"},
    { "name" :"501(c)(13) Cemetery Companies"},
    { "name" :"501(c)(14) Credit Unions and Other Mutual Financial Organizations"},
    { "name" :"501(c)(15) Mutual Insurance Company other than Life or Marine"},
    { "name" :"501(c)(16) Corporations Financing Crop Operations"},
    { "name" :"501(c)(17) Supplemental Unemployment Compensations Trust or Plan"},
    { "name" :"501(c)(18) Employee Funded Pension Trust formed prior to June 1959"},
    { "name" :"501(c)(19) Post or Organizations of War Veterans"},
    { "name" :"501(c)(2) Title Holding Corporation"},
    { "name" :"501(c)(20) Group Legal Services Plan Organization"},
    { "name" :"501(c)(21) Black Lung Benefit Trusts"},
    { "name" :"501(c)(23) Veterans Association formed prior to 1880"},
    { "name" :"501(c)(24) Trust described in Section 4049 or ERISA"},
    { "name" :"501(c)(25) Title Holding Corporations for Multiple Organizations (Pensions, etc.)"},
    { "name" :"501(c)(26) State Sponsored High Risk Health Insurance Organization"},
    { "name" :"501(c)(27) State Sponsored Workers Compensation Reinsurances"},
    { "name" :"501(c)(29) ACA 1322 Qualified Nonprofit Health Insurance Issuers"},
    {"name":"501(c)(3) Private Non-Operating Foundation"},
    {"name":"501(c)(3) Private operating foundation"},
    {"name":"501(c)(3) Public Charity"},
    {"name":"501(c)(4) Civic Leagues and Social Welfare Organizations"},
    {"name":"501(c)(5) Labor, Agricultural and Horticultural Organizations"},
    {"name":"501(c)(6) Business Leagues, etc."},
    {"name":"501(c)(7) Social and Recreation Clubs"},
    {"name":"501(c)(8) Fraternal Beneficiary Societies"},
    {"name":"501(c)(8) Fraternal Beneficiary Societies"},
    {"name":"501(c)(9) Employees Associations"},
    {"name":"501(d) Apostolic and Religious Organizations"},
    {"name":"501(e) Cooperative Hospital Service Organizations"},
    {"name":"501(n) Charitable Risk Pools"},
    {"name":"521(a) Farmers’ Cooperative"},
    {"name":"527 Political Organizations"}
]

  
 


